<template>
    <div class="financial-accounting parent-frame" :class="{'fixed': listIsFixed}"  v-bind:style="{'min-height': myHeight}">
        <div class="tool-bar-mask"></div>
        <new-accounting></new-accounting>
        <Breadcrumb />
        <h1>記帳本</h1>
        <div class="btn-group">
            <div class="default-button new-accounting-btn" @click="newAccounting">
                <img src="@/assets/img/icon/plus_white.svg" alt="">
                新增記帳
            </div>
            <table-search @changeWord="setFilterWord" ></table-search>
            <div class="filter" @click="openFilter()">
                <img src="@/assets/img/icon/filter_white.svg" alt="">
            </div>
        </div>
        <accounting-book-filter :isOpen="isFilter" @filterClose="closeFilter" @changeFilter="setFilterQuery"></accounting-book-filter>
        <financial-accounting></financial-accounting>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import financialAccounting from '@/components/landlord/financialManagement/financialAccounting.vue';
import accountingBookFilter from '@/components/landlord/financialManagement/accountingBookFilter.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import NewAccounting from '@/components/widge/NewAccounting.vue';
import { mapGetters } from 'vuex'

export default {
    name: 'TenantManagement',
    data () {
        return {
            hash: null,
            myHeight: (window.innerHeight) + 'px',
            listIsFixed: false,
            isFilter: false,
            selected: {
                chart: false,
                list: false,
            },
            componentKey: 0,
        }
    },
    created (){
        // console.log(this.$route)
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        // $route:{
        //     handler: function (val) {
        //         this.hash = val.hash
        //     },
        //     immediate: true,
        //     deep: true
        // }
        isModalMode: function (val) {
            if(val){
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            }else{
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
            }
            
        }
    },
    methods: {
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                if( scrollTop >= 50){
                    document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
        openFilter: function () {
            this.isFilter = true
            this.$store.commit('modalStatus/set_filter_mode', true)
            document.getElementsByClassName('financial-accounting')[0].style.zIndex = '9'
        },
        closeFilter: function (value) {
            this.isFilter = value
            this.$store.commit('modalStatus/set_filter_mode', false)
        },
        setFilterWord: function (value) {
            this.$store.dispatch('setAccountingFilterWord', value)
        },
        setFilterQuery: function (value) {
            console.log(value)
            this.$store.dispatch('setAccountingFilterQuery', value)
        },
        newAccounting: function () {
            this.$store.dispatch('sendEventLog', 'CREATE_LEDGER')  
            this.$analytics.logEvent('新增記帳', { screen_name: '新增記帳'})
            this.$store.dispatch('setModalStatus', {state: true, type: 'newAccounting'})
        },
    },
    computed: {
        ...mapGetters({
            isModalMode: 'GET_MODAL_MODE'
        })
    },
    components: {
        financialAccounting,
        accountingBookFilter,
        TableSearch,
        Breadcrumb,
        NewAccounting
    }
}
</script>
<style lang="scss" scoped>
    .financial-accounting{
        position: relative;
        margin-top: 123px;
        .breadcrumb{
            position: absolute;
            top: -43px;
        }
        > h1{
            margin-top: 26px;
            margin-bottom: 40px;
            font-size: 28px;
        }
        >.btn-group{
            position: absolute;
            display: flex;
            align-items: center;
            top: 4px;
            right: 20px;
            .new-accounting-btn{
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                width: 120px;
                padding: 10px 0;
                margin-right: 16px;
                font-weight: 500;
            }
            .filter{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 44px;
                height: 44px;
                cursor: pointer;
                background: #a8a5a4;
                border-radius: 4px;
                margin-left: 16px;
            }
        }
    }
    .financial-accounting.fixed{
        .tool-bar-mask{
            position: fixed;
            width: 100%;
            background: #fff;
            height: 80px;
            top: 0px;
            z-index: 7;
            margin-left: -39px;
            border-bottom: 1px solid #f0f0f0;
        }
        >h1{
            position: fixed;
            top: -5px;
            z-index: 8;
        }
        >.btn-group{
            position: fixed;
            top: 18px;
            right: unset;
            z-index: 8;
            margin-left: 727px;
        }
    }
    @media screen and (max-width: 1280px){
        .financial-accounting{
            
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/financialManagementPages/financialAccountingBook.vue